module.exports = __webpack_public_path__ + "media/bootstrap-icons/tools-ddcd4312.svg";